var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas-container"},[(_vm.canvasImage)?_c('img',{staticClass:"canvas-image",staticStyle:{"{\n        max-width":"100%,"},attrs:{"src":_vm.canvasImage}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }